var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54442 9.39357C10.2872 8.39857 10.7368 7.115 10.7368 5.71429C10.7368 2.56357 8.47011 0 5.68421 0H0V8.57143V11.4286V20H6.94737C9.73326 20 12 17.4364 12 14.2857C12 12.21 11.0128 10.3943 9.54442 9.39357ZM2.52632 2.85714H5.68421C7.07747 2.85714 8.21053 4.13857 8.21053 5.71429C8.21053 7.29 7.07747 8.57143 5.68421 8.57143H2.52632V2.85714ZM6.94737 17.1429H2.52632V11.4286H5.68421H6.94737C8.34063 11.4286 9.47368 12.71 9.47368 14.2857C9.47368 15.8614 8.34063 17.1429 6.94737 17.1429Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldSign);
export default __webpack_public_path__ + "static/media/bold_sign.46381465aa8c8b9d408c94fad20b5338.svg";
export { ForwardRef as ReactComponent };